import { makeStyles, tokens } from '@fluentui/react-components';
import { ottoTokens } from '@/theme/ottoTokens';

export const useNoteStyles = makeStyles({
  noteWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    '& .react-flow__resize-control.line': {
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent',
      borderLeftColor: 'transparent',
      borderTopWidth: tokens.strokeWidthThick,
      borderRightWidth: tokens.strokeWidthThick,
      borderBottomWidth: tokens.strokeWidthThick,
      borderLeftWidth: tokens.strokeWidthThick,
    },
    '& .react-flow__resize-control.handle': {
      width: tokens.spacingHorizontalXS,
      height: tokens.spacingHorizontalXS,
      backgroundColor: tokens.colorBrandBackground,
      borderTopColor: tokens.colorBrandBackground,
      borderRightColor: tokens.colorBrandBackground,
      borderBottomColor: tokens.colorBrandBackground,
      borderLeftColor: tokens.colorBrandBackground,
      borderTopLeftRadius: tokens.borderRadiusSmall,
      borderTopRightRadius: tokens.borderRadiusSmall,
      borderBottomRightRadius: tokens.borderRadiusSmall,
      borderBottomLeftRadius: tokens.borderRadiusSmall,
    },
  },
  resizerVisible: {
    '& .react-flow__resize-control.line': {
      borderTopColor: tokens.colorBrandStroke1,
      borderRightColor: tokens.colorBrandStroke1,
      borderBottomColor: tokens.colorBrandStroke1,
      borderLeftColor: tokens.colorBrandStroke1,
    },
  },
  noteCard: {
    width: '100%',
    height: '100%',
    borderRadius: tokens.borderRadiusLarge,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    color: ottoTokens.noteForeground,
    cursor: 'default',
    transitionProperty: 'box-shadow',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease',
    overflowWrap: 'break-word',
    boxSizing: 'border-box',
  },
  selected: {
    boxShadow: ottoTokens.noteBorderSelected,
  },
  draggingNote: {
    boxShadow: `${ottoTokens.noteBorderSelected}, ${tokens.shadow16}`,
    '& iframe': {
      pointerEvents: 'none',
    },
  },
  noteTextarea: {
    width: '100%',
    height: '100%',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    color: ottoTokens.noteForeground,
    fontSize: tokens.fontSizeBase200,
    lineHeight: '1.5',
    fontFamily: 'inherit',
    padding: 0,
    resize: 'none',
    cursor: 'text',
  },
  markdownContainer: {
    overflow: 'auto',
    cursor: 'pointer',
    height: '100%',
    '& :first-child': {
      marginTop: 0,
    },
    '& :last-child': {
      marginBottom: 0,
    },
  },
  noteToolbar: {
    position: 'absolute',
    bottom: '-32px',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    opacity: 0,
    transitionProperty: 'opacity',
    transitionDuration: '0.15s',
  },
  noteToolbarVisible: {
    opacity: 1,
  },
  toolbarButton: {
    minWidth: 'auto',
    padding: tokens.spacingVerticalXS,
    color: tokens.colorNeutralForeground3,
    ':hover': {
      color: tokens.colorNeutralForeground1,
    },
  },
  // Color picker popover
  colorPickerContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingVerticalS,
  },
  colorSwatch: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    cursor: 'pointer',
    transitionProperty: 'transform, box-shadow',
    transitionDuration: '0.1s',
    ':hover': {
      transform: 'scale(1.1)',
    },
  },
  colorSwatchSelected: {
    boxShadow: `0 0 0 2px ${tokens.colorNeutralBackground1}, 0 0 0 4px ${tokens.colorNeutralStrokeAlpha2}`,
  },
  placeholder: {
    color: tokens.colorNeutralForeground4,
    fontStyle: 'italic',
    fontSize: tokens.fontSizeBase200,
  },
  // Markdown element styles
  markdownHeading: {
    fontWeight: tokens.fontWeightSemibold,
    color: ottoTokens.noteForeground,
    margin: `${tokens.spacingVerticalS} 0 ${tokens.spacingVerticalXS} 0`,
  },
  markdownParagraph: {
    margin: `${tokens.spacingVerticalXS} 0`,
    fontSize: tokens.fontSizeBase200,
    lineHeight: '1.5',
    color: ottoTokens.noteForeground,
  },
  markdownList: {
    margin: `${tokens.spacingVerticalXS} 0`,
    paddingLeft: tokens.spacingHorizontalXL,
    fontSize: tokens.fontSizeBase200,
    color: ottoTokens.noteForeground,
  },
  markdownImage: {
    maxWidth: '100%',
    borderRadius: tokens.borderRadiusSmall,
  },
  youtubeEmbed: {
    width: '100%',
    aspectRatio: '16 / 9',
    border: 'none',
    borderRadius: tokens.borderRadiusSmall,
  },
});
